import { TextField } from '@mui/material'
import { NumberRegexp } from '../../../utils'
import { IFilterComponentProps } from 'components/Table/TableFilter/types'
import { inputStyles } from '../Inputs.style'

function NumberFilterInput({
  value,
  columnId,
  handleFilterState,
  startAdornment,
}: IFilterComponentProps) {
  const handleChange = (e) => {
    if (e.target.value === '' || NumberRegexp.test(e.target.value)) {
      handleFilterState(columnId, null, e?.target?.value)
    }
  }

  const inputValue = value === undefined || value === null ? '' : value

  return (
    <TextField
      fullWidth
      value={inputValue}
      onChange={handleChange}
      variant="standard"
      InputProps={{ startAdornment }}
      sx={inputStyles}
    />
  )
}

export default NumberFilterInput
